// KAPI · presentation · CTA + telefon

import { useRef } from "react";
import { SectionShell } from "@/features/landing/components/SectionShell";
import { COPY } from "@/features/landing/content/landing-copy";
import { useKapiMotion } from "./Kapi.motion";
import styles from "./Kapi.module.css";

export function Kapi() {
  const scopeRef = useRef<HTMLElement | null>(null);
  useKapiMotion(scopeRef);

  return (
    <SectionShell id="kapi" ariaLabelledBy="kapi-title" tone="ink" container="default">
      <div className={styles.kapi} ref={scopeRef as unknown as React.RefObject<HTMLDivElement>}>
        <div className={styles.kapi__inner}>
          <div>
            <p className={styles.kapi__eyebrow}>{COPY.kapi.chapter} · Kapı</p>
            <h2 className={styles.kapi__title} id="kapi-title">{COPY.kapi.title}</h2>
            <p className={styles.kapi__sub}>{COPY.kapi.sub}</p>
          </div>

          <a
            href={COPY.kapi.phoneHref}
            className={styles.kapi__contact}
            aria-label={`Telefonla ara: ${COPY.kapi.phone}`}
          >
            <span className={styles["kapi__phone"]}>
              <span className={styles["kapi__phone-label"]}>Doğrudan hat · {COPY.kapi.ctaLabel}</span>
              <span className={styles["kapi__phone-num"]}>{COPY.kapi.phone}</span>
            </span>
            <span className={styles.kapi__hours}>{COPY.kapi.hours}</span>
          </a>
        </div>
      </div>
    </SectionShell>
  );
}